import type { JSX } from 'react';
import { Navigate, useSearchParams } from 'react-router';

import { ServiceCode } from '@/shared/types';

import { ROUTES, ROUTES_BY_SERVICE_CODE } from '../router/config';

export const GercRedirectMiddleware = (): JSX.Element => {
  const queryParams = useSearchParams()[0];
  const requestId = queryParams.get('requestId');
  const serviceCode = queryParams.get('serviceCode') as ServiceCode;

  return (
    <Navigate
      to={ROUTES_BY_SERVICE_CODE[serviceCode] || ROUTES.HOME}
      state={{
        continueGercPayment: true,
        request_id: Number(requestId),
      }}
    />
  );
};
